@if(isOnline()){
    <app-notification/>
    <router-outlet/>
    <app-loader />
    <div id="form-dialog-root-wrapper"></div>
}@else {
    <app-offline/>
}